export default __webpack_public_path__ + "static/media/spark_88.e085a29b.png";